import _taggedTemplateLiteral from "/codebuild/output/src748241224/src/github.com/EverlyWell/www/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  margin-top: ", "px;\n\n  ", " {\n    margin-top: ", "px;\n  }\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  overflow: hidden;\n  position: relative;\n  flex-direction: column;\n  ", " {\n    flex: 1 1;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    flex: 0 0 290px;\n    padding-right: 46px;\n  }\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  ", " {\n    color: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  right: 0;\n  ", " {\n    border: 1px solid ", ";\n    padding: 11px 14px 10px 13px;\n    background: rgba(214, 235, 221, 0.3);\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " {\n    border: 1px solid ", ";\n    padding: 11px 14px 10px 13px;\n    background: rgba(214, 235, 221, 0.3);\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  ", "\n  position: absolute;\n  top: 101px;\n  z-index: 0;\n\n  ", " {\n    position: absolute;\n    top: 159px;\n  }\n\n  ", " {\n    top: 50%;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { css } from "styled-components";
import { ChipContainer } from "../../Chips";
import { mediaQueries, size, colors } from "../../../shared/constants";
import { control as controlBase, ControlIcon as ControlIconBase } from "../SliderContainer/styles";
export var Slider = styled.div(_templateObject());
export var control = css(_templateObject2(), controlBase, mediaQueries.forTabletVerticalUp, mediaQueries.forDesktopUp);
export var LeftControl = styled.button(_templateObject3(), control, mediaQueries.forTabletVerticalUp, colors.green2);
export var RightControl = styled.button(_templateObject4(), control, mediaQueries.forTabletVerticalUp, colors.green2);
export var ControlIcon = styled(ControlIconBase)(_templateObject5(), colors.teal3, mediaQueries.forTabletVerticalUp, colors.green5);
export var ControlsContainer = styled.div(_templateObject6(), mediaQueries.forTabletHorizontalUp);
export var SlideContainer = styled.div(_templateObject7(), mediaQueries.forTabletHorizontalUp);
export var Chips = styled(ChipContainer)(_templateObject8(), size.xs1, mediaQueries.forDesktopUp, size.md);